import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      id: "save-drafts",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveDraftsDialogVisible = true)),
      plain: "",
      type: "warning"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('saveAllDrafts.saveAllDraftsButton')) + " ", 1),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bttn-img" }, [
          _createElementVNode("span", { class: "material-symbols-outlined" }, " add_comment ")
        ], -1))
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.saveDraftsDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saveDraftsDialogVisible) = $event)),
      title: _ctx.$t('saveAllDrafts.saveAllDraftsPopup'),
      width: "30%",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: _ctx.closeSaveDraftsDialog }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('generic.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.saveAllDrafts
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('generic.confirm')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "message",
          innerHTML: _ctx.$t('saveAllDrafts.saveDrftsMessageHtml')
        }, null, 8, _hoisted_1),
        _createVNode(_component_el_collapse, {
          modelValue: _ctx.activeCollapse,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeCollapse) = $event)),
          onChange: _ctx.onCollapseChange,
          class: "include-edited"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              name: "includeEdited",
              title: _ctx.$t('saveAllDrafts.includeEditedTitle')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "reason",
                  innerHTML: _ctx.$t('saveAllDrafts.includeEditedReason')
                }, null, 8, _hoisted_2),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.includeEdited,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.includeEdited) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('saveAllDrafts.includeEdited')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}